module.exports = __webpack_public_path__ + "media/images/ico-28f22d3f6260d6d94c85f366c72b3a39.png";